export default __webpack_public_path__ + "static/media/new-logo.e7598b32.png";